import { useOutletContext } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { FixtureRewards } from '@sorare/gameplay/src/components/rewards/FixtureRewards';

import { PageParams } from './__generated__/routeParams';

const RewardsFixturePage = () => {
  const { fixture } = useTypedParams<PageParams>();
  const { isUpcoming, onlyMyCompetitions } = useOutletContext<{
    isUpcoming: boolean;
    onlyMyCompetitions: boolean;
  }>();
  return (
    <FixtureRewards
      fixture={fixture}
      isUpcoming={isUpcoming}
      onlyMyCompetitions={onlyMyCompetitions}
      sport={Sport.NBA}
    />
  );
};

export default RewardsFixturePage;
